






import { Component, Mixins } from "vue-property-decorator";
import { ISourcePrintable } from "..";
import { SourcePrintableMixin } from "../mixins";

@Component({
})
export default class ChromePdfPrinter extends Mixins(SourcePrintableMixin) implements ISourcePrintable {
  data(): any {
    return {
      isLoaded: true,
    };
  }
  isLoaded: boolean;

  printSource(source: string, copies: number, shouldSelectPrinter: boolean) {
    // 部数と出力先はブラウザ任せなので無視.
    if (source === "") {
      return;
    }
    this.sourceToPrint = null;  // v-ifで1度objectをDOMから削除を促す
    this.$nextTick(() => {
      this.isLoaded = false;
      this.sourceToPrint = source;
    });
  }

  onLoaded(): void {
    if (!this.shouldShow) {
      return;
    }
    this.isLoaded = true;

    // 印刷開始
    const chrome = this.$refs.chrome as HTMLIFrameElement;
    chrome.contentWindow.focus();
    chrome.contentWindow.print();
  }
}
